var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-coming-soon",style:(_vm.styles)},[_c('p',{staticClass:"coming-soon-title"},[_vm._v("Coming Soon")]),_vm._v(" "),_c('p',{staticClass:"coming-soon-desc"},[_vm._v("暴露数の相性が占えるコーナーを準備中。お楽しみに！")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42874265","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Products/houen/partials/BlockComingSoon.vue
// module id = null
// module chunks = 